import { makeStyles } from '@material-ui/core'
import { loginBackground } from 'src/assets/png'

export const useStyles = makeStyles((theme) => ({
  changePasswordContainer: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: theme.app.spacing.base,
    alignItems: 'stretch',
    color: '#FFF',
    background: `linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), ${theme.palette.primary.main}`,
    padding: 0,
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: 0,
      justifyContent: 'center',
      alignItems: 'center',
      background: '#301e1a'
    },

    '& .change-password__button': {
      height: 56,
      fontSize: theme.app.typography.body.fontSize,
      fontWeight: 500,
      color: '#FFFFFF',
      width: '100%',
      border: 'none',
      backgroundColor: theme.palette.primary.main,
      boxShadow: '0px 2px 8px rgba(120, 74, 66, 0.15)',
      borderRadius: theme.app.borderRadius.lg,
      marginTop: 20,
      cursor: 'pointer',
      textAlign: 'center',
      transition: 'all 0.2s',
      '&:hover': {
        backgroundColor: '#6a3f38'
      },
      '&:disabled': {
        opacity: 0.6,
        cursor: 'not-allowed'
      }
    }
  },

  changePasswordForm: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: '40px 60px',
    gap: theme.app.spacing.xxl,
    flex: 1,
    minWidth: 0,
    maxWidth: 732,
    height: '100vh',
    overflow: 'auto',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      maxWidth: 'unset',
      padding: 30,
      gap: theme.app.spacing.xxl,
      height: 'auto'
    },
    '& form': {
      width: '100%'
    }
  },

  changePasswordImageSide: {
    width: 708,
    height: '100vh',
    backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${loginBackground})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },

  changePasswordTitleWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    width: '100%',
    maxWidth: 532,
    '& h1': {
      fontFamily: theme.app.typography.fontFamily.main,
      fontStyle: 'normal',
      fontWeight: 900,
      fontSize: 28,
      lineHeight: '150%',
      color: theme.app.colors.text.light,
      margin: 0
    }
  },

  changePasswordInfoWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 20,
    width: '100%',
    maxWidth: 400,
    '& h2': {
      fontFamily: theme.app.typography.fontFamily.main,
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: theme.app.typography.h2.fontSize,
      lineHeight: '150%',
      color: theme.app.colors.text.light,
      margin: 0,
      width: '100%'
    }
  },

  changePasswordDescription: {
    fontFamily: theme.app.typography.fontFamily.main,
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: theme.app.typography.body.fontSize,
    lineHeight: '150%',
    color: '#FFFFFF',
    margin: 0
  },

  changePasswordInput: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.app.spacing.xs,
    width: '100%',
    marginTop: theme.app.spacing.base,
    '&:first-of-type': {
      marginTop: 0
    },
    '& label': {
      fontFamily: theme.app.typography.fontFamily.main,
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: theme.app.typography.label.fontSize,
      lineHeight: '150%',
      color: theme.app.colors.text.light,
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.app.typography.paragraph.fontSize
      }
    },
    '& input': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      padding: `${theme.app.spacing.md}px ${theme.app.spacing.base}px`,
      width: '100%',
      height: 48,
      background: theme.app.colors.input.background,
      borderRadius: theme.app.borderRadius.sm,
      border: 'none',
      fontFamily: theme.app.typography.fontFamily.main,
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: theme.app.typography.body.fontSize,
      lineHeight: '150%',
      color: theme.app.colors.text.light,
      boxSizing: 'border-box',
      '&:focus': {
        outline: 'none',
        background: theme.app.colors.input.backgroundFocus
      },
      '&::placeholder': {
        color: 'rgba(250, 250, 250, 0.5)'
      },
      '&:disabled': {
        opacity: 0.6,
        cursor: 'not-allowed'
      }
    }
  },

  changePasswordError: {
    display: 'block',
    fontSize: theme.app.typography.paragraph.fontSize,
    color: '#ff6b6b',
    marginTop: 6,
    fontFamily: theme.app.typography.fontFamily.main,
    fontWeight: 400
  },

  changePasswordButtons: {
    width: '100%',
    marginTop: 0
  }
}))
